import { fulfilmentToken } from "@/services/customer";
import{ jwtDecode } from "jwt-decode";


export const isTokenExpired = (token) => {
  if (!token) return new Promise((resolve) => resolve(false));
  const now = new Date();
  if (token && jwtDecode(token)) {
    const expiry = jwtDecode(token);
    return new Promise((resolve) =>
      resolve(now.getTime() / 1000 + 60 < expiry.exp)
    );
  }
  return new Promise((resolve) => resolve(false));
};

export function isTokenValid(token) {
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    if (decoded.exp && decoded.exp < currentTime) {
      return false;
    }

    return true;
  } catch (error) {
    return false;
  }
}
export const giftcardToken = async () => {
  try {
    const body = {
      client_id: "progcap_180225062305638754565883678805",
      secret_key: "RitVqDgkQs3qF7Py4fY7Ds0oCJldVrpEJIUcAOX3kg=",
    };
    const response = await fulfilmentToken(body);
    if (
      response.message.success === true &&
      response.message.data.access_token
    ) {
      localStorage.setItem("fulfil_token", response.message.data.access_token);
      return response.message.data.access_token;
    }

    return null;
  } catch (err) {
    return null;
  }
};
